<div class="row row-sm">
    <div class="col-lg-12">
        <!-- <div class="card custom-card"> -->
        <div class="card-body">
            <div class="row">
                <div class="col-md-12">
                    <div class="bc d-flex align-items-center pl-3">
                        <img alt="Logo" src="../../assets/img/ExamMaster.png" class="mh-45px pb-2">
                        <div *ngIf="submitButton" class="mb-0">
                            <h3 class="main-content-label mb-1"><b>Exam Schedule</b></h3>
                            <p class="text-muted card-sub-title mb-0">{{'header.exam-schedule.titleList.AddNewInfo' |
                                translate}}</p>
                        </div>
                        <div *ngIf="editButton" class="mb-0">
                            <h3 class="main-content-label mb-1"><b>Exam Schedule</b></h3>
                            <p class="text-muted card-sub-title mb-0 ">
                                {{'header.exam-schedule.titleList.UpdateSelectedInfo' | translate}}
                            </p>
                        </div>
                        <div *ngIf="deleteButton" class="mb-0">
                            <h3 class="main-content-label mb-1"><b>Exam Schedule</b></h3>
                            <p class="text-muted card-sub-title mb-0 ">
                                {{'header.exam-schedule.titleList.DeleteSelectedInfo' | translate}}
                            </p>
                        </div>
                    </div>
                </div>
                <hr class="mt-3">

                    <div class="row row-sm add-form" >
                        <form autocomplete="off" class="p-0" novalidate [formGroup]="ExamSchForm">
                            <div class="col-lg-12 col-md-12">
    
                                    <div class="card-body">
                                        <div class="row clearfix">
                                            <div class="col-sm-4">
                                                <div class="form-group">
                                                  <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width"  >
                                                      <mat-label>
                                                        {{'header.exam-schedule.titleList.ExmSchOpen' | translate}}
                                                    </mat-label>
                                                    <!-- <input matInput formControlName="CoGPAm" placeholder="CoGPAm"required> -->
                                                    <mat-select #select56 formControlName="ShEmId" [disabled]="isread"
                                                        [disabled]="isreaddelete">
                                                        <mat-select-filter *ngIf="select56.focused"
                                                            [placeholder]="'Filter'" [displayMember]="'EmName'"
                                                            [array]="examList"
                                                            (filteredReturn)="filteredListExam =$event">
                                                        </mat-select-filter>
                                                        <mat-option *ngFor="let item of filteredListExam"
                                                            [value]="item.EmId" (click)="getExam(item)">
                                                            {{item.EmCode}} - {{item.EmName}}
                                                        </mat-option>
                                                    </mat-select>
                                                    <mat-error class="margin_tp"
                                                        *ngIf="ExamSchForm.controls['ShEmId'].touched && ExamSchForm.controls['ShEmId'].errors?.required">
                                                        Mandatory
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <div class="">
                                                <mat-form-field appearance="outline" class="example-full-width ">
                                                    <mat-label>
                                                        {{'header.exam-schedule.titleList.ExmSchExmName' | translate}}
                                                    </mat-label>
                                                    <input [readonly]="isreaddelete" [readonly]="true" maxlength="80"
                                                        onkeydown="return (event.keyCode!=13);" style="color:black;"
                                                        type="text" placeholder="Exam Name" formControlName="EmName"
                                                        matInput>
                                                    <!-- <mat-error class="margin_tp"
                                                      *ngIf="ExamSchForm.controls['EmName'].touched && ExamSchForm.controls['EmName'].errors?.required">
                                                      Mandatory
                                                  </mat-error>  -->
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-3" *ngIf="ExamSFormArray['ShExtr1'][0]['FormVisible']">
                                        <div class="form-group">
                                            <div class="">
                                                <section class="example-section mt-4">
                                                    <mat-checkbox [readonly]="isreaddelete" [readonly]="isread"
                                                        class="example-margin "
                                                        formControlName="ShExtr1">{{ExamSFormArray['ShExtr1'][0]['FormDisplayName']}}
                                                        <span
                                                            *ngIf="ExamSFormArray['ShExtr1'][0]['FormRequired']">*</span></mat-checkbox>
                                                </section>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <div class="">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>
                                                        {{'header.exam-schedule.titleList.ExmSchStatus' | translate}}
                                                    </mat-label>
                                                    <mat-select #select56 formControlName="ShStatus" [disabled]="isread"
                                                        [disabled]="isreaddelete">
                                                        <mat-option value="O">Open</mat-option>
                                                        <mat-option value="C">Close</mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- <div class="col-sm-4">
                                        <div class="form-group">
                                            <div class="">
                                                <mat-form-field appearance="outline" class="example-full-width ">
                                                    <mat-label>
                                                        {{'header.exam-schedule.titleList.ExmSchImagePath' | translate}}
                                                    </mat-label>
                                                    <input [readonly]="isreaddelete" [readonly]="isread"
                                                        onkeydown="return (event.keyCode!=13);" style="color:black;"
                                                        placeholder="File Path:" type="text" formControlName="ShPath"
                                                        matInput>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-3 example-full-width ">
                                        <button [disabled]="isreaddelete" class="file-upload-button example-full-width 
                                        sz btn  me-2 mt-0  btn-icon-text btn-raised g-bg-blush2"><input
                                                type="file" #fileInput (change)="onFileSelect(fileInput)" />
                                                <span style="display: contents; align-items: center;">
                                                    
                                                        Select Path
                                                </span>
                                            
                                        </button>
                                    </div> -->
                                    <!-- <div class="col-sm-3">
                                                <div class="form-group">
                                                    <button class="file-upload-button btn btn-primary my-2 me-2 mt-0 mb-4 btn-icon-text btn-raised g-bg-blush2">
                                                        {{'header.exam-schedule.titleList.ExmSchButton' | translate}}
                                                    </button>
                                                </div>
                                            </div>  -->
                                    <div class="col-sm-3" *ngIf="ExamSFormArray['TempTextCheck'][0]['FormVisible']">
                                        <div class="form-group">
                                            <div class="">
                                                <section class="example-section mt-4">
                                                    <mat-checkbox class="example-margin "
                                                        formControlName="TempTextCheck">{{ExamSFormArray['TempTextCheck'][0]['FormDisplayName']}}
                                                        <span
                                                            *ngIf="ExamSFormArray['TempTextCheck'][0]['FormRequired']">*</span></mat-checkbox>
                                                </section>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-4" *ngIf="ExamSFormArray['TempBranches'][0]['FormVisible']">
                                        <div class="form-group">
                                            <div class="">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>
                                                        {{ExamSFormArray['TempBranches'][0]['FormDisplayName']}}
                                                        <span
                                                            *ngIf="ExamSFormArray['TempBranches'][0]['FormRequired']">*</span>
                                                    </mat-label>
                                                    <mat-select onkeydown="return (event.keyCode!=13);" #select55
                                                        formControlName="TempBranches">
                                                        <mat-select-filter *ngIf="select55.focused"
                                                            [placeholder]="'Filter'" [displayMember]="'StrId'"
                                                            [array]="BranchList"
                                                            (filteredReturn)="filteredListBranch =$event"></mat-select-filter>
                                                        <mat-option *ngFor="let item of filteredListBranch"
                                                            [value]="item.StrId">
                                                            {{item.StrName}}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                  
                                    <div class="row col-sm-12">
                                        <div class="col-sm-12 prpl ">
                                            <button type="button" *ngIf="deleteButton && ExDelete"
                                                class="btn btn-primary btn-icon-text floatright mt-1 fr"
                                                (click)="DeletetheRecord()">
                                                <span style="display: contents; align-items: center;">
                                                    <img width="20vh" src="../../assets/img/trash.gif"
                                                        style="margin-right: 5px;">
                                                    Delete
                                                </span>
                                            </button>
                                            
                                                <button id="printbtn" type="button" *ngIf="editButton"
                                                    class="btn btn-primary btn-icon-text floatright mt-1 fr"
                                                    (click)="print()">
                                                    <span style="display: flex; align-items: center;">
                                                        <img width="20vh" src="../../assets/img/printer.gif"
                                                            style="margin-right: 5px;">
                                                        Print
                                                    </span>
                                                </button>
                                            
                                            <button type="button" *ngIf="editButton && ExUpdate"
                                                class="btn btn-primary btn-icon-text floatright mt-1 mr-3 fr"
                                                (click)="update()">
                                                <span style="display: contents; align-items: center;">
                                                    <img width="20vh" src="../../assets/img/edit1.gif"
                                                        style="margin-right: 5px;">
                                                    Update
                                                </span>
                                            </button>
                                            <button type="button" *ngIf="submitButton && ExCreate"
                                                class="btn btn-primary btn-icon-text  mt-1 mr-3 fr" (click)="submit()">
                                                <span style="display: contents; align-items: center;">
                                                    <img width="20vh" src="../../assets/img/save.gif"
                                                        style="margin-right: 5px;">
                                                    Save
                                                </span>
                                            </button>
                                            <button type="button" [mat-dialog-close]="true"
                                                class="btn btn-primary btn-icon-text  mt-1 mr-3 fr">
                                                <span style="display: contents; align-items: center;">
                                                    <img width="20vh" src="../../assets/img/turn-left.gif"
                                                        style="margin-right: 7px;">
                                                    Back
                                                </span>
                                            </button>



                                        </div>

                                    </div>
                                </div>
                            </div>
                            <!-- </div> -->
                        </div>
                    </form>
                </div>
            </div>
        </div>

    </div>
</div>